export type ICountry = {
  value: string;
  id: string;
  ueorch: boolean;
};

export const countries = [
  {
    value: "Ukraina",
    id: "UKR",
    ueorch: false,
  },
  {
    value: "Austria",
    id: "AUT",
    ueorch: true,
  },
  {
    value: "Barbados",
    id: "BRB",
    ueorch: false,
  },
  {
    value: "Bułgaria",
    id: "BGR",
    ueorch: true,
  },
  {
    value: "Chorwacja",
    id: "HRV",
    ueorch: true,
  },
  {
    value: "Cypr",
    id: "CYP",
    ueorch: true,
  },
  {
    value: "Czechy",
    id: "CZE",
    ueorch: true,
  },
  {
    value: "Dania",
    id: "DNK",
    ueorch: true,
  },
  {
    value: "Estonia",
    id: "EST",
    ueorch: true,
  },
  {
    value: "Finlandia",
    id: "FIN",
    ueorch: true,
  },
  {
    value: "Francja",
    id: "FRA",
    ueorch: true,
  },
  {
    value: "Grecja",
    id: "GRC",
    ueorch: true,
  },
  {
    value: "Hiszpania",
    id: "ESP",
    ueorch: true,
  },
  {
    value: "Holandia",
    id: "NLD",
    ueorch: true,
  },
  {
    value: "Irlandia",
    id: "IRL",
    ueorch: true,
  },
  {
    value: "Litwa",
    id: "LTU",
    ueorch: true,
  },
  {
    value: "Luksemburg",
    id: "LUX",
    ueorch: true,
  },
  {
    value: "Łotwa",
    id: "LVA",
    ueorch: true,
  },
  {
    value: "Malta",
    id: "MLT",
    ueorch: true,
  },
  {
    value: "Niemcy",
    id: "DEU",
    ueorch: true,
  },
  {
    value: "Polska",
    id: "POL",
    ueorch: true,
  },
  {
    value: "Portugalia",
    id: "PRT",
    ueorch: true,
  },
  {
    value: "Rumunia",
    id: "ROU",
    ueorch: true,
  },
  {
    value: "Słowacja",
    id: "SVK",
    ueorch: true,
  },
  {
    value: "Słowenia",
    id: "SVN",
    ueorch: true,
  },
  {
    value: "Szwajcaria",
    id: "CHE",
    ueorch: true,
  },
  {
    value: "Szwecja",
    id: "SWE",
    ueorch: true,
  },
  {
    value: "Węgry",
    id: "HUN",
    ueorch: true,
  },
  {
    value: "Włochy",
    id: "ITA",
    ueorch: true,
  },
  {
    value: "Afganistan",
    id: "AFG",
    ueorch: false,
  },
  {
    value: "Albania",
    id: "ALB",
    ueorch: false,
  },
  {
    value: "Algieria",
    id: "DZA",
    ueorch: false,
  },
  {
    value: "Andora",
    id: "AND",
    ueorch: false,
  },
  {
    value: "Angola",
    id: "AGO",
    ueorch: false,
  },
  {
    value: "Anguilla",
    id: "AIA",
    ueorch: false,
  },
  {
    value: "Antarktyka",
    id: "ATA",
    ueorch: false,
  },
  {
    value: "Antigua i Barbuda",
    id: "ATG",
    ueorch: false,
  },
  {
    value: "Arabia Saudyjska",
    id: "SAU",
    ueorch: false,
  },
  {
    value: "Argentyna",
    id: "ARG",
    ueorch: false,
  },
  {
    value: "Armenia",
    id: "ARM",
    ueorch: false,
  },
  {
    value: "Aruba",
    id: "ABW",
    ueorch: false,
  },
  {
    value: "Australia",
    id: "AUS",
    ueorch: false,
  },
  {
    value: "Azerbejdżan",
    id: "AZE",
    ueorch: false,
  },
  {
    value: "Bahamy",
    id: "BHS",
    ueorch: false,
  },
  {
    value: "Bahrajn",
    id: "BHR",
    ueorch: false,
  },
  {
    value: "Bangladesz",
    id: "BGD",
    ueorch: false,
  },
  {
    value: "Belgia",
    id: "BEL",
    ueorch: true,
  },
  {
    value: "Belize",
    id: "BLZ",
    ueorch: false,
  },
  {
    value: "Benin",
    id: "BEN",
    ueorch: false,
  },
  {
    value: "Bermudy",
    id: "BMU",
    ueorch: false,
  },
  {
    value: "Bhutan",
    id: "BTN",
    ueorch: false,
  },
  {
    value: "Białoruś",
    id: "BLR",
    ueorch: false,
  },
  {
    value: "Boliwia",
    id: "BOL",
    ueorch: false,
  },
  {
    value: "Bonaire, Sint Eustatius i Saba",
    id: "BES",
    ueorch: false,
  },
  {
    value: "Bośnia i Hercegowina",
    id: "BIH",
    ueorch: false,
  },
  {
    value: "Botswana",
    id: "BWA",
    ueorch: false,
  },
  {
    value: "Brazylia",
    id: "BRA",
    ueorch: false,
  },
  {
    value: "Brunei",
    id: "BRN",
    ueorch: false,
  },
  {
    value: "Brytyjskie Terytorium Oceanu Indyjskiego",
    id: "IOT",
    ueorch: false,
  },
  {
    value: "Brytyjskie Wyspy Dziewicze",
    id: "VGB",
    ueorch: false,
  },
  {
    value: "Burkina Faso",
    id: "BFA",
    ueorch: false,
  },
  {
    value: "Burundi",
    id: "BDI",
    ueorch: false,
  },
  {
    value: "Chile",
    id: "CHL",
    ueorch: false,
  },
  {
    value: "Chiny",
    id: "CHN",
    ueorch: false,
  },
  {
    value: "Curaçao",
    id: "CUW",
    ueorch: false,
  },
  {
    value: "Czad",
    id: "TCD",
    ueorch: false,
  },
  {
    value: "Czarnogóra",
    id: "MNE",
    ueorch: false,
  },
  {
    value: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
    id: "UMI",
    ueorch: false,
  },
  {
    value: "Demokratyczna Republika Konga",
    id: "COD",
    ueorch: false,
  },
  {
    value: "Dominika",
    id: "DMA",
    ueorch: false,
  },
  {
    value: "Dominikana",
    id: "DOM",
    ueorch: false,
  },
  {
    value: "Dżibuti",
    id: "DJI",
    ueorch: false,
  },
  {
    value: "Egipt",
    id: "EGY",
    ueorch: false,
  },
  {
    value: "Ekwador",
    id: "ECU",
    ueorch: false,
  },
  {
    value: "Erytrea",
    id: "ERI",
    ueorch: false,
  },
  {
    value: "Eswatini",
    id: "SWZ",
    ueorch: false,
  },
  {
    value: "Etiopia",
    id: "ETH",
    ueorch: false,
  },
  {
    value: "Falklandy",
    id: "FLK",
    ueorch: false,
  },
  {
    value: "Fidżi",
    id: "FJI",
    ueorch: false,
  },
  {
    value: "Filipiny",
    id: "PHL",
    ueorch: false,
  },
  {
    value: "Francuskie Terytoria Południowe i Antarktyczne",
    id: "ATF",
    ueorch: false,
  },
  {
    value: "Gabon",
    id: "GAB",
    ueorch: false,
  },
  {
    value: "Gambia",
    id: "GMB",
    ueorch: false,
  },
  {
    value: "Georgia Południowa i Sandwich Południowy",
    id: "SGS",
    ueorch: false,
  },
  {
    value: "Ghana",
    id: "GHA",
    ueorch: false,
  },
  {
    value: "Gibraltar",
    id: "GIB",
    ueorch: false,
  },
  {
    value: "Grenada",
    id: "GRD",
    ueorch: false,
  },
  {
    value: "Grenlandia",
    id: "GRL",
    ueorch: false,
  },
  {
    value: "Gruzja",
    id: "GEO",
    ueorch: false,
  },
  {
    value: "Guam",
    id: "GUM",
    ueorch: false,
  },
  {
    value: "Guernsey",
    id: "GGY",
    ueorch: false,
  },
  {
    value: "Gujana Francuska",
    id: "GUF",
    ueorch: false,
  },
  {
    value: "Gujana",
    id: "GUY",
    ueorch: false,
  },
  {
    value: "Gwadelupa",
    id: "GLP",
    ueorch: false,
  },
  {
    value: "Gwatemala",
    id: "GTM",
    ueorch: false,
  },
  {
    value: "Gwinea Bissau",
    id: "GNB",
    ueorch: false,
  },
  {
    value: "Gwinea Równikowa",
    id: "GNQ",
    ueorch: false,
  },
  {
    value: "Gwinea",
    id: "GIN",
    ueorch: false,
  },
  {
    value: "Haiti",
    id: "HTI",
    ueorch: false,
  },
  {
    value: "Honduras",
    id: "HND",
    ueorch: false,
  },
  {
    value: "Hongkong",
    id: "HKG",
    ueorch: false,
  },
  {
    value: "Indie",
    id: "IND",
    ueorch: false,
  },
  {
    value: "Indonezja",
    id: "IDN",
    ueorch: false,
  },
  {
    value: "Irak",
    id: "IRQ",
    ueorch: false,
  },
  {
    value: "Iran",
    id: "IRN",
    ueorch: false,
  },
  {
    value: "Islandia",
    id: "ISL",
    ueorch: false,
  },
  {
    value: "Izrael",
    id: "ISR",
    ueorch: false,
  },
  {
    value: "Jamajka",
    id: "JAM",
    ueorch: false,
  },
  {
    value: "Japonia",
    id: "JPN",
    ueorch: false,
  },
  {
    value: "Jemen",
    id: "YEM",
    ueorch: false,
  },
  {
    value: "Jersey",
    id: "JEY",
    ueorch: false,
  },
  {
    value: "Jordania",
    id: "JOR",
    ueorch: false,
  },
  {
    value: "Kajmany",
    id: "CYM",
    ueorch: false,
  },
  {
    value: "Kambodża",
    id: "KHM",
    ueorch: false,
  },
  {
    value: "Kamerun",
    id: "CMR",
    ueorch: false,
  },
  {
    value: "Kanada",
    id: "CAN",
    ueorch: false,
  },
  {
    value: "Katar",
    id: "QAT",
    ueorch: false,
  },
  {
    value: "Kazachstan",
    id: "KAZ",
    ueorch: false,
  },
  {
    value: "Kenia",
    id: "KEN",
    ueorch: false,
  },
  {
    value: "Kirgistan",
    id: "KGZ",
    ueorch: false,
  },
  {
    value: "Kiribati",
    id: "KIR",
    ueorch: false,
  },
  {
    value: "Kolumbia",
    id: "COL",
    ueorch: false,
  },
  {
    value: "Komory",
    id: "COM",
    ueorch: false,
  },
  {
    value: "Kongo",
    id: "COG",
    ueorch: false,
  },
  {
    value: "Korea Południowa",
    id: "KOR",
    ueorch: false,
  },
  {
    value: "Korea Północna",
    id: "PRK",
    ueorch: false,
  },
  {
    value: "Kostaryka",
    id: "CRI",
    ueorch: false,
  },
  {
    value: "Kuba",
    id: "CUB",
    ueorch: false,
  },
  {
    value: "Kuwejt",
    id: "KWT",
    ueorch: false,
  },
  {
    value: "Laos",
    id: "LAO",
    ueorch: false,
  },
  {
    value: "Lesotho",
    id: "LSO",
    ueorch: false,
  },
  {
    value: "Liban",
    id: "LBN",
    ueorch: false,
  },
  {
    value: "Liberia",
    id: "LBR",
    ueorch: false,
  },
  {
    value: "Libia",
    id: "LBY",
    ueorch: false,
  },
  {
    value: "Liechtenstein",
    id: "LIE",
    ueorch: false,
  },
  {
    value: "Macedonia Północna",
    id: "MKD",
    ueorch: false,
  },
  {
    value: "Madagaskar",
    id: "MDG",
    ueorch: false,
  },
  {
    value: "Majotta",
    id: "MYT",
    ueorch: false,
  },
  {
    value: "Makau",
    id: "MAC",
    ueorch: false,
  },
  {
    value: "Malawi",
    id: "MWI",
    ueorch: false,
  },
  {
    value: "Malediwy",
    id: "MDV",
    ueorch: false,
  },
  {
    value: "Malezja",
    id: "MYS",
    ueorch: false,
  },
  {
    value: "Mali",
    id: "MLI",
    ueorch: false,
  },
  {
    value: "Mariany Północne",
    id: "MNP",
    ueorch: false,
  },
  {
    value: "Maroko",
    id: "MAR",
    ueorch: false,
  },
  {
    value: "Martynika",
    id: "MTQ",
    ueorch: false,
  },
  {
    value: "Mauretania",
    id: "MRT",
    ueorch: false,
  },
  {
    value: "Mauritius",
    id: "MUS",
    ueorch: false,
  },
  {
    value: "Meksyk",
    id: "MEX",
    ueorch: false,
  },
  {
    value: "Mikronezja",
    id: "FSM",
    ueorch: false,
  },
  {
    value: "Mjanma",
    id: "MMR",
    ueorch: false,
  },
  {
    value: "Mołdawia",
    id: "MDA",
    ueorch: false,
  },
  {
    value: "Monako",
    id: "MCO",
    ueorch: false,
  },
  {
    value: "Mongolia",
    id: "MNG",
    ueorch: false,
  },
  {
    value: "Montserrat",
    id: "MSR",
    ueorch: false,
  },
  {
    value: "Mozambik",
    id: "MOZ",
    ueorch: false,
  },
  {
    value: "Namibia",
    id: "NAM",
    ueorch: false,
  },
  {
    value: "Nauru",
    id: "NRU",
    ueorch: false,
  },
  {
    value: "Nepal",
    id: "NPL",
    ueorch: false,
  },
  {
    value: "Niger",
    id: "NER",
    ueorch: false,
  },
  {
    value: "Nigeria",
    id: "NGA",
    ueorch: false,
  },
  {
    value: "Nikaragua",
    id: "NIC",
    ueorch: false,
  },
  {
    value: "Niue",
    id: "NIU",
    ueorch: false,
  },
  {
    value: "Norfolk",
    id: "NFK",
    ueorch: false,
  },
  {
    value: "Norwegia",
    id: "NOR",
    ueorch: false,
  },
  {
    value: "Nowa Kaledonia",
    id: "NCL",
    ueorch: false,
  },
  {
    value: "Nowa Zelandia",
    id: "NZL",
    ueorch: false,
  },
  {
    value: "Oman",
    id: "OMN",
    ueorch: false,
  },
  {
    value: "Pakistan",
    id: "PAK",
    ueorch: false,
  },
  {
    value: "Palau",
    id: "PLW",
    ueorch: false,
  },
  {
    value: "Palestyna",
    id: "PSE",
    ueorch: false,
  },
  {
    value: "Panama",
    id: "PAN",
    ueorch: false,
  },
  {
    value: "Papua-Nowa Gwinea",
    id: "PNG",
    ueorch: false,
  },
  {
    value: "Paragwaj",
    id: "PRY",
    ueorch: false,
  },
  {
    value: "Peru",
    id: "PER",
    ueorch: false,
  },
  {
    value: "Pitcairn",
    id: "PCN",
    ueorch: false,
  },
  {
    value: "Polinezja Francuska",
    id: "PYF",
    ueorch: false,
  },
  {
    value: "Portoryko",
    id: "PRI",
    ueorch: false,
  },
  {
    value: "Południowa Afryka",
    id: "ZAF",
    ueorch: false,
  },
  {
    value: "Republika Środkowoafrykańska",
    id: "CAF",
    ueorch: false,
  },
  {
    value: "Republika Zielonego Przylądka",
    id: "CPV",
    ueorch: false,
  },
  {
    value: "Reunion",
    id: "REU",
    ueorch: false,
  },
  {
    value: "Rosja",
    id: "RUS",
    ueorch: false,
  },
  {
    value: "Rwanda",
    id: "RWA",
    ueorch: false,
  },
  {
    value: "Sahara Zachodnia",
    id: "ESH",
    ueorch: false,
  },
  {
    value: "Saint Kitts i Nevis",
    id: "KNA",
    ueorch: false,
  },
  {
    value: "Saint Lucia",
    id: "LCA",
    ueorch: false,
  },
  {
    value: "Saint Vincent i Grenadyny",
    id: "VCT",
    ueorch: false,
  },
  {
    value: "Saint-Barthélemy",
    id: "BLM",
    ueorch: false,
  },
  {
    value: "Saint-Martin",
    id: "MAF",
    ueorch: false,
  },
  {
    value: "Saint-Pierre i Miquelon",
    id: "SPM",
    ueorch: false,
  },
  {
    value: "Salwador",
    id: "SLV",
    ueorch: false,
  },
  {
    value: "Samoa Amerykańskie",
    id: "ASM",
    ueorch: false,
  },
  {
    value: "Samoa",
    id: "WSM",
    ueorch: false,
  },
  {
    value: "San Marino",
    id: "SMR",
    ueorch: false,
  },
  {
    value: "Senegal",
    id: "SEN",
    ueorch: false,
  },
  {
    value: "Serbia",
    id: "SRB",
    ueorch: false,
  },
  {
    value: "Seszele",
    id: "SYC",
    ueorch: false,
  },
  {
    value: "Sierra Leone",
    id: "SLE",
    ueorch: false,
  },
  {
    value: "Singapur",
    id: "SGP",
    ueorch: false,
  },
  {
    value: "Sint Maarten",
    id: "SXM",
    ueorch: false,
  },
  {
    value: "Somalia",
    id: "SOM",
    ueorch: false,
  },
  {
    value: "Sri Lanka",
    id: "LKA",
    ueorch: false,
  },
  {
    value: "Stany Zjednoczone",
    id: "USA",
    ueorch: false,
  },
  {
    value: "Sudan",
    id: "SDN",
    ueorch: false,
  },
  {
    value: "Sudan Południowy",
    id: "SSD",
    ueorch: false,
  },
  {
    value: "Surinam",
    id: "SUR",
    ueorch: false,
  },
  {
    value: "Svalbard i Jan Mayen",
    id: "SJM",
    ueorch: false,
  },
  {
    value: "Syria",
    id: "SYR",
    ueorch: false,
  },
  {
    value: "Tadżykistan",
    id: "TJK",
    ueorch: false,
  },
  {
    value: "Tajlandia",
    id: "THA",
    ueorch: false,
  },
  {
    value: "Tajwan",
    id: "TWN",
    ueorch: false,
  },
  {
    value: "Tanzania",
    id: "TZA",
    ueorch: false,
  },
  {
    value: "Timor Wschodni",
    id: "TLS",
    ueorch: false,
  },
  {
    value: "Togo",
    id: "TGO",
    ueorch: false,
  },
  {
    value: "Tokelau",
    id: "TKL",
    ueorch: false,
  },
  {
    value: "Tonga",
    id: "TON",
    ueorch: false,
  },
  {
    value: "Trynidad i Tobago",
    id: "TTO",
    ueorch: false,
  },
  {
    value: "Tunezja",
    id: "TUN",
    ueorch: false,
  },
  {
    value: "Turcja",
    id: "TUR",
    ueorch: false,
  },
  {
    value: "Turkmenistan",
    id: "TKM",
    ueorch: false,
  },
  {
    value: "Turks i Caicos",
    id: "TCA",
    ueorch: false,
  },
  {
    value: "Tuvalu",
    id: "TUV",
    ueorch: false,
  },
  {
    value: "Uganda",
    id: "UGA",
    ueorch: false,
  },
  {
    value: "Urugwaj",
    id: "URY",
    ueorch: false,
  },
  {
    value: "Uzbekistan",
    id: "UZB",
    ueorch: false,
  },
  {
    value: "Vanuatu",
    id: "VUT",
    ueorch: false,
  },
  {
    value: "Wallis i Futuna",
    id: "WLF",
    ueorch: false,
  },
  {
    value: "Watykan",
    id: "VAT",
    ueorch: false,
  },
  {
    value: "Wenezuela",
    id: "VEN",
    ueorch: false,
  },
  {
    value: "Wielka Brytania",
    id: "GBR",
    ueorch: false,
  },
  {
    value: "Wietnam",
    id: "VNM",
    ueorch: false,
  },
  {
    value: "Wybrzeże Kości Słoniowej",
    id: "CIV",
    ueorch: false,
  },
  {
    value: "Wyspa Bouveta",
    id: "BVT",
    ueorch: false,
  },
  {
    value: "Wyspa Bożego Narodzenia",
    id: "CXR",
    ueorch: false,
  },
  {
    value: "Wyspa Man",
    id: "IMN",
    ueorch: false,
  },
  {
    value: "Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha",
    id: "SHN",
    ueorch: false,
  },
  {
    value: "Wyspy Alandzkie",
    id: "ALA",
    ueorch: false,
  },
  {
    value: "Wyspy Cooka",
    id: "COK",
    ueorch: false,
  },
  {
    value: "Wyspy Dziewicze Stanów Zjednoczonych",
    id: "VIR",
    ueorch: false,
  },
  {
    value: "Wyspy Heard i McDonalda",
    id: "HMD",
    ueorch: false,
  },
  {
    value: "Wyspy Kokosowe",
    id: "CCK",
    ueorch: false,
  },
  {
    value: "Wyspy Marshalla",
    id: "MHL",
    ueorch: false,
  },
  {
    value: "Wyspy Owcze",
    id: "FRO",
    ueorch: false,
  },
  {
    value: "Wyspy Salomona",
    id: "SLB",
    ueorch: false,
  },
  {
    value: "Wyspy Świętego Tomasza i Książęca",
    id: "STP",
    ueorch: false,
  },
  {
    value: "Zambia",
    id: "ZMB",
    ueorch: false,
  },
  {
    value: "Zimbabwe",
    id: "ZWE",
    ueorch: false,
  },
  {
    value: "Zjednoczone Emiraty Arabskie",
    id: "ARE",
    ueorch: false,
  },
];
